export default __webpack_public_path__ + "static/media/icon.575417a1.svg";